<script>
export default {
  name: 'LoadingIndicator',
};
</script>

<template functional>
  <div class="loading-indicator__wrapper">
    <span class="loading-indicator__circle loading-indicator__left"></span>
    <span class="loading-indicator__circle loading-indicator__middle"></span>
    <span class="loading-indicator__circle loading-indicator__right"></span>
  </div>
</template>
